import { render, staticRenderFns } from "./PromotionInvitationTable.vue?vue&type=template&id=01e389b8"
import script from "./PromotionInvitationTable.vue?vue&type=script&lang=js"
export * from "./PromotionInvitationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports